// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__eiNcb","brand":"navbar_brand__otMAw","navLinks":"navbar_navLinks__hMc3j"};